/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EdiDeliverySettingsResponse } from "./EdiDeliverySettingsResponse";
import {
  EdiDeliverySettingsResponseFromJSON,
  EdiDeliverySettingsResponseFromJSONTyped,
  EdiDeliverySettingsResponseToJSON,
  EdiDeliverySettingsResponseToJSONTyped,
} from "./EdiDeliverySettingsResponse";

/**
 * Wrapper so the GET can answer "this partner has no settings yet" with a 200. Returning the nullable response straight from the controller made Micronaut answer a null with a non-2xx, which the generated client turns into a thrown ResponseError and \`DataBoundary\` renders as "Something went wrong" -- an error screen on every company that has never been set up, which is most of them. Not being configured is an ordinary state, not a failure. A 200 with an empty body is not an option either: the generated client calls \`response.json()\` and throws on it.
 * @export
 * @interface GetEdiDeliverySettingsResponse
 */
export interface GetEdiDeliverySettingsResponse {
  /**
   *
   * @type {EdiDeliverySettingsResponse}
   * @memberof GetEdiDeliverySettingsResponse
   */
  settings?: EdiDeliverySettingsResponse | null;
}

/**
 * Check if a given object implements the GetEdiDeliverySettingsResponse interface.
 */
export function instanceOfGetEdiDeliverySettingsResponse(
  value: object,
): value is GetEdiDeliverySettingsResponse {
  return true;
}

export function GetEdiDeliverySettingsResponseFromJSON(
  json: any,
): GetEdiDeliverySettingsResponse {
  return GetEdiDeliverySettingsResponseFromJSONTyped(json, false);
}

export function GetEdiDeliverySettingsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetEdiDeliverySettingsResponse {
  if (json == null) {
    return json;
  }
  return {
    settings:
      json["settings"] == null
        ? undefined
        : EdiDeliverySettingsResponseFromJSON(json["settings"]),
  };
}

export function GetEdiDeliverySettingsResponseToJSON(
  json: any,
): GetEdiDeliverySettingsResponse {
  return GetEdiDeliverySettingsResponseToJSONTyped(json, false);
}

export function GetEdiDeliverySettingsResponseToJSONTyped(
  value?: GetEdiDeliverySettingsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    settings: EdiDeliverySettingsResponseToJSON(value["settings"]),
  };
}
